const translations = {
  "users.UserName": "User Name",
  "users.Email": "Email",
  "users.Phone": "Phone",
  "users.DisplayName": "Display name",
  "users.MustChangePassword": "Must Change Password",
  "users.IsActive": "Is Active",
  "users.AddUser": "Add User",
  "users.EditUser": "Edit User",
  "users.UserExists": "User already exists",
  "users.Role": "User role",
  "users.Employee": "Employee",
  "users.Roles": "Permission group",
};

export default translations;
